module.exports = __webpack_public_path__ + "img/arepa_mixta.c4fa7fc0.jpeg";